import {
    LIST_SERVICES_REQUEST,
    LIST_SERVICES_SUCCESS,
    LIST_SERVICES_FAILURE,
} from 'api/index';

const initialSettings = null;

const services = (state = initialSettings, action) => {
    switch (action.type) {
        
        case LIST_SERVICES_SUCCESS:
            return action.payload.services;

//        case LIST_SERVICES_REQUEST:
        case LIST_SERVICES_FAILURE:
            return null;

        default:
            return state;
    }
};

export default services;